import React, { FC } from "react";
import EPGAdminLayout from "../../../layouts/admin/EPGAdminLayout";
import MultiDayEpg from "./components/MultiDayEpg";
import {
    usePlanbyChannels,
    usePlanbyEventCollectionByDateByChannelTag,
} from "../../../services/epg/Query";
import { calculateEpgDates } from "../../../services/epg/Util";

const EPGGridView: FC = () => {

    const { data: channels } = usePlanbyChannels();

    const channelTags = channels?.map((channel => channel.uuid));

    const { data: eventCollectionByDateByChannelTag } = usePlanbyEventCollectionByDateByChannelTag(channelTags);

    const dates = calculateEpgDates(eventCollectionByDateByChannelTag);

    return (
        <>
            <EPGAdminLayout heading="EPG">
                <div className="h-full flex flex-col mr-6">
                    <MultiDayEpg
                        dates={dates}
                        channels={channels}
                        eventsByDateByChannel={eventCollectionByDateByChannelTag}
                    />
                </div>
            </EPGAdminLayout>
        </>
    );
};

export default EPGGridView;